import { createStore, getActionIds } from '../helpers/redux';
import Immutable, {Map, List} from 'immutable';
import omit from 'lodash/omit';
import first_ from 'lodash/first';
import last_ from 'lodash/last';
import sortBy_ from 'lodash/sortBy';
import { differenceInWeekDays } from '../shared/helpers/dateHelpers';
import subDays from 'date-fns/subDays';
import getDay from 'date-fns/getDay';
import parseISO from 'date-fns/parseISO';

import { ViewActions } from '../actions/view';
import { RelationshipActions } from '../actions/relationship';
// import { ViewElementActions } from '../actions/viewElement';
import { ProjectActions } from '../actions/project';
import { ElementActions } from '../actions/element';

const projectActions = getActionIds(ProjectActions);
const viewActions = getActionIds(ViewActions);
const relationshipActions = getActionIds(RelationshipActions);
// const viewElementActions = getActionIds(ViewElementActions);
const elementActions = getActionIds(ElementActions);

const initialState = Immutable.fromJS({
  views: {
    // 60: {
      // relationships: {
      //   420117: [],
      //   420118: []
      // },
      // viewElements: {
      //   420117: {
      //   },
      //   420118: {
      //   }
      // },
      // refElements: []
    // }
  },
  meta: {
    sortType: null
  },
  loading: [],
  loaded: []
});

export const views = createStore(initialState, {
  // ['*']: (state, action) => {
  // },

  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [relationshipActions.createRelationships.success]: (state, action) => {
    return state.get('views').reduce((state, view, index, array) => {
      if(view.has('relationships')){
        let newView = view.get('relationships').reduce((v, relationship, index, array) => {
          let viewType = v.get('type_id');

          switch (viewType) {
            case '2':
            case 2:
              if (List.isList(index)){
                return v.deleteIn(['relationships', index]);
              }
              break;
            case '3':
            case 3:
              if (List.isList(index)){
                return v.deleteIn(['relationships', index]);
              }
              break;
            default:
              return v;
          }

          return v;
        }, view)

        return state.setIn(['views', index], newView);
      } else {
        const typeId = view.get('type_id');
        let newView = view;

        if (typeId === 4 && !view.getIn(['meta', 'cyclesOnly'], false)) {
          newView = view.deleteIn(['meta', 'partition']);
        }

        return state.setIn(['views', index], newView);
      }
    }, state)
  },

  [relationshipActions.deleteRelationships.success]: (state, action) => {
    return state.get('views').reduce((state, view, index, array) => {
      if(view.has('relationships')){
        return state;
      } else {
        const typeId = view.get('type_id');

        if (typeId === 4) {
          return state.setIn(['views', index], view.deleteIn(['meta', 'partition']).setIn(['meta', 'cyclesOnly'], false));
        } else {
          return state.setIn(['views', index], view);
        }


      }
    }, state)
  },

  [relationshipActions.updateProperty.success]: (state, action) => {
    return state.get('views').reduce((prev, cur, viewId) => {
      if (cur.get('type_id') === 4 && !cur.getIn(['meta', 'cyclesOnly'])) {
        return prev.setIn(['views', viewId], cur.deleteIn(['meta', 'partition']));
      }
      return prev.setIn(['views', viewId], cur);
    }, state);
  },

  [relationshipActions.deleteRelationship.success]: (state, action) => {
    return state.get('views').reduce((state, view, index, array) => {
      if(view.has('relationships')){
        let newView = view.get('relationships').reduce((v, relationship, index, array) => {
          let v2;
          let viewType = v.get('type_id');

          switch (viewType) {
            case '2':
            case 2:
              if (List.isList(index)){
                if (index.indexOf(action.args[0].get('consumer')) > -1 || index.indexOf(action.args[0].get('producer')) > -1) {
                  v2 = v.setIn(['meta', 'needsRefresh'], true);

                  return v2.deleteIn(['relationships', index]);
                }
              }
              break;
            case '3':
            case 3:
              // const indexOfRel = v.get('relationships').indexOf(action.args[0].get('id'));
              let relationships = v.get('relationships');

              if (relationships) {
                relationships.forEach((rel, relId) => {
                  if (List.isList(relId)) {
                    relationships = relationships.delete(relId)
                  }
                });
              }

              return v.setIn(['relationships'], relationships);
            default:
              return v;
          }

          return v;
        }, view)

        return state.setIn(['views', index], newView);
      } else {
        return state.setIn(['views', index], view);
      }
    }, state)
  },

  [elementActions.clientDeleteElements]: (state, action) => {
    var views = state.get('views');

    views = views.map((view) => {
      if(view.get('viewElements')){
        var elementRefs = view.get('elementRefs');
        var display = view.get('display');
        var levels = view.get('levels');
        var relationships = view.get('relationships');
        var viewElements = view.get('viewElements');

        elementRefs = elementRefs.filter((ref) => {
          return action.elementIds.indexOf(ref) === -1;
        })

        action.elementIds.forEach((elementId) => {
          let parentId = viewElements.getIn([elementId, 'parentable_id']);

          display = display.delete(elementId);
          levels = levels.delete(elementId);
          relationships = relationships.delete(elementId);
          relationships = relationships.get(parentId) ? relationships.set(parentId, List(relationships.get(parentId).delete(relationships.get(parentId).indexOf(elementId)))) : relationships;

          viewElements = viewElements.setIn([parentId, 'childrenCount'], viewElements.getIn([parentId, 'childrenCount']) - 1);

          if(relationships.get(parentId)){
            if(relationships.get(parentId).size === 0 && elementRefs.indexOf(parentId) > -1){
              elementRefs = elementRefs.filter((eId) => {
                return eId !== parentId;
              })

              display = display.set(parentId, !display.get(parentId))
            }
          }

          viewElements = viewElements.delete(elementId);

        })

        relationships = relationships.map((child) => {
          return child.filter((childId) => {
            return action.elementIds.indexOf(childId) === -1
          })
        })


        return view.setIn(['elementRefs'], elementRefs).setIn(['display'], display).setIn(['levels'], levels).setIn(['relationships'], relationships).setIn(['viewElements'], viewElements)
      }
      return view
    })

    return state.setIn(['views'], views);
  },

  [viewActions.setSelectedCell]: (state, action) => {
    let selectedCell = state.getIn(['views', action.viewId, 'meta', 'selectedCell'], List());

    let obj = Map({
      consumer: null,
      producer: null
    });

    if(action.producer && action.consumer){
      obj = obj.set('producer', action.producer);
      obj = obj.set('consumer', action.consumer);
    }

    if (action.multi && obj.get('producer') && obj.get('consumer')) {
      const indexOfSelectedCell = selectedCell.findIndex((a) => {
        return a.get('producer') === action.producer && a.get('consumer') === action.consumer;
      });

      if (indexOfSelectedCell > -1) {
        selectedCell = selectedCell.delete(indexOfSelectedCell);

        if (selectedCell.size === 0) {
          selectedCell = List().push(Map({
            producer: null,
            consumer: null
          }));
        }
      } else {
        selectedCell = selectedCell.push(obj);
      }
    } else {
      selectedCell = List().push(obj);
    }

    return state.setIn(['views', action.viewId, 'meta', 'selectedCell'], Immutable.fromJS(selectedCell));
  }, 

  [relationshipActions.getRelationships.success]: (state, action) => {
    return state.mergeDeep({
      views: {
        [action.args[1]]: {
          meta: {
            selectedCell: {
              producer: action.args[2],
              consumer: action.args[3]
            }
          }
        }
      }
    }).setIn(['views', action.args[1], 'allRelationships', action.args[2] + '-' + action.args[3]], List(action.result.result));
  },

  [viewActions.getView.success]: (state, action) => {

    const data = action.result.entities.views[action.result.result].data;

    let view = action.result.entities.views[action.result.result];

    Object.assign(view, data)

    view = omit(view, 'data');

    return state.mergeDeep({
      views: {
        [action.result.result]: view
      }
    });
  },

});

export const shouldLoadViewDataSelector = (state, props) => {
  const { currentViewId } = props;

  if (!currentViewId) return true;

  const loading = state.views.get('loading').indexOf(currentViewId) === -1;
  const loaded = state.views.get('loaded').indexOf(currentViewId) === -1;

  return loading && loaded;
};

export const viewDataLoadedSelector = (state, props) => {
  const { currentViewId } = props;

  if (!currentViewId) return true;

  return state.views.get('loaded').indexOf(currentViewId) === -1;
};

export const cyclesOnlySelector = (state, props) => {
  const { currentViewId } = props;

  return state.views.getIn(['views', currentViewId, 'meta', 'cyclesOnly'], false)
}

export const partitionSelector = (state, props) => {
  const { currentViewId } = props;

  return state.views.getIn(['views', currentViewId, 'meta', 'partition'], List())
};

export const buildCircleHash = (elements, eleRels, rels) => {
  if (rels.size === 0 || eleRels.size === 0) return Map();

  let circleHashMap = Map();

  elements.forEach((a) => {
    const relsToMap = eleRels.getIn([a.get('id'), 'consumesFrom'], List());
    relsToMap.forEach((relId) => {
      const rel = rels.get(relId);
      if (!rel) return null;
      const producer = rel.get('producer');
      const consumer = rel.get('consumer');
      const hiddenOrFull = rel.getIn(['props', 'Assumption', 'hidden'], false) ? 'hidden' : 'full';

      circleHashMap = circleHashMap.setIn([consumer, producer], {
        value: hiddenOrFull,
        relationship: rel,
      });
    });
  });

  return circleHashMap;
};

export const buildPartitionHash = (partition) => {
  const obj = {};

  partition.forEach((a) => {
    const first = first_(a);
    const last = last_(a);

    obj[first] = {};

    if (a.length === 1) {
      obj[first][first] = null;
    } else {
      obj[last] = {};

      obj[first][first] = 'top-left';
      obj[first][last] = 'top-right';
      obj[last][last] = 'bottom-right';
      obj[last][first] = 'bottom-left';

      a.forEach((b) => {
        if (b !== first && b !== last) {
          obj[first][b] = 'top';
          obj[last][b] = 'bottom';
          obj[b] = {};
          obj[b][first] = 'left';
          obj[b][last] = 'right';
        }
      });
    }
  });

  return obj;
}


export const buildFilteredList = (filteredElements, currentUser, elements) => {
  const userId = currentUser.get('id', '0');

  return filteredElements.filter((ele) => {
    const element = elements.get(ele);
    return element.getIn(['props', 'Responsibility'], null) === userId;
  });
}

export const buildSortedList = (filteredElements, elements, relationshipsMapping, sortType, elementType) => {
  const elementTypeName = elementType.get('type');

  const sortTypeIds = sortType.reduce((prev, sort) =>
    prev.push(elementType.getIn(['props', sort, '_typeOptions', '[RT]relationship_type']))
  , List());

  const relationships = relationshipsMapping.filter((array, relTypeId) => {
    return sortTypeIds.indexOf(relTypeId) > -1;
  });

  return filteredElements.reduce((prev, element) => {
    const placeToPush = sortTypeIds.size > 0 ? sortTypeIds.reduce((acc, sort) => {
      const entity = relationships.getIn([sort, element], 'Unspecified');
      const entityName = entity !== 'Unspecified' ?
        elements.getIn([entity.get('producer'), 'name']) : 'Unspecified';
      return acc.push(entityName);
    }, List()) : List().push(`${elementTypeName}s`);

    const indexOfFirstUnspecified = placeToPush.indexOf('Unspecified');

    const actualPlaceToPush = (placeToPush.size > 1 && indexOfFirstUnspecified > -1) ?
      placeToPush.slice(0, indexOfFirstUnspecified + 1) :
      placeToPush;

    const currentmapping = prev.getIn(actualPlaceToPush, List());
    const elementCopy = elements.get(element).set('level', actualPlaceToPush.size);
    return prev.setIn(actualPlaceToPush, currentmapping.push(Map().set('element', elementCopy)));
  }, Map());
}

export const buildElementsList = (
  filteredElements,
  elements,
  elementType,
  taskTypeId,
  relationshipsMapping,
  currentUser,
  sortType,
  filterType,
) => {
  // const {
  //   filteredElements,
  //   elements,
  //   elementType,
  //   taskTypeId,
  //   relationshipsMapping,
  //   currentUser,
  // } = this.props;

  // const {
  //   sortType,
  //   filterType,
  // } = this.state;

  if (filteredElements.size === 0) return List();

  const allElements = filterType ?
    buildFilteredList(filteredElements, currentUser, elements) :
    filteredElements;

  return buildSortedList(allElements, elements, relationshipsMapping, sortType, elementType);
}

const sortHelper = (ele, sortBy) => {
  if (sortBy === 'Alphabetical') {
    return ele.get('name').toLowerCase();
  } else {
    return parseInt(ele.get('id'), 10);
  }
}

export const buildFlatListNew = (
  orderedWbsElements,
  elements,
  filteredElements,
  relationships,
  wbsRelTypeId,
  sortBy,
  filterType,
  currentUser,
) => {
  const wbsRelationships = relationships.get(wbsRelTypeId, Map());

  const filteredElementsList = filterType ?
    buildFilteredList(filteredElements, currentUser, elements) : filteredElements;

  const wbsElementMapping = {};
  const elementsVisited = {};
  let displayUnspecifiedHeader = false;

  wbsRelationships.forEach((rel) => {
    const taskElement = elements.get(rel.get('consumer'));
    if (taskElement && filteredElements.indexOf(taskElement.get('id')) > -1 ) {
      const wbsElementId = rel.get('producer');

      const wbsElementRef = wbsElementMapping[wbsElementId] || List();
      wbsElementMapping[wbsElementId] = wbsElementRef.push(taskElement)
    }
  });

  const orderedWbsArray = orderedWbsElements.reduce((prev, cur) => {
    const wbsEleId = cur.get('id');
    const wbsElementRef = wbsElementMapping[wbsEleId];
    const wbsEleLevel = cur.get('level');
    if (wbsElementRef) {
      prev.push(cur)
      wbsElementRef.sortBy(ele => sortHelper(ele, sortBy)).map(ele => {
        const newElement = ele.set('level', wbsEleLevel + 1);
        elementsVisited[ele.get('id')] = true;
        return Map({ element: newElement })
      }).forEach(ele => prev.push(ele));
    } else {
      prev.push(cur);
    }
    return prev;
  }, []);

  const sortedFilteredElements = sortBy_(filteredElementsList.reduce((prev, cur) => {
    if (!elementsVisited[cur]) {
      displayUnspecifiedHeader = true;
      elementsVisited[cur] = true;
      prev.push(Map({
        element: elements.get(cur).set('level', 1)
      }));
    }
    return prev;
  }, []), ele => sortHelper(ele.get('element'), sortBy)).concat(orderedWbsArray);

  if (displayUnspecifiedHeader) {
    sortedFilteredElements.unshift(Map({
      title: 'Unspecified',
      level: 0,
      type: null,
      id: null,
    }));
  }

  const immutablesortedFilteredElements = Immutable.fromJS(sortedFilteredElements);

  return {
    flatList: immutablesortedFilteredElements,
    rowCount: immutablesortedFilteredElements.size,
  };
}

export const buildFlatList = (
  sortType,
  sortBy,
  filteredElements,
  elements,
  elementType,
  taskTypeId,
  relationshipsMapping,
  currentUser,
  filterType,
) => {
  const elementsByType = buildElementsList(
    filteredElements,
    elements,
    elementType,
    taskTypeId,
    relationshipsMapping,
    currentUser,
    sortType,
    filterType,
  );
  let flatList = List();
  let rowCount = 0;

  // const {
  //   sortType,
  //   sortBy,
  // } = this.state;

  const recurse = (mapping, level) => {
    mapping.sortBy((a, b) => {
      return b;
    }).forEach((entity, entityTitle) => {
      flatList = flatList.concat(List().push(Map()
        .set('title', entityTitle)
        .set('level', level)
        .set('type', sortType ? sortType.get(level) : null))
      );

      rowCount += 1;

      if (List.isList(entity)) {
        const sortedList = entity.sortBy((a) => {
          if (sortBy === 'Alphabetical') {
            return a.getIn(['element', 'name']).toLowerCase();
          } else {
            return parseInt(a.getIn(['element', 'id']), 10);
          }
        });

        flatList = flatList.concat(sortedList);

        rowCount += entity.size;
      } else {
        const newlevel = level + 1;
        recurse(entity, newlevel);
      }
    });
  };

  recurse(elementsByType, 0);

  return {
    flatList,
    rowCount,
  };
}


const dataBuilder = (type, entity, elementInfo, offset) => {
  if (type === 'wbs') {
    return {
      colIndex: -1,
      color: 'black',
      duration: 1,
      id: entity ? entity.get('id') : null,
      level: entity ? entity.get('level') : 0,
      name: entity ? entity.get('title') : 'Unspecified',
      rowIndex: 0,
      successors: List(),
      type: 'wbs',
      onCriticalPath: false,
    };
  } else {
    return {
      colIndex: elementInfo.weekDaysOnStart + offset,
      color: type === 'task' ? 'lightblue' : '#5f5e5e',
      duration:
        type === 'task' ? elementInfo.duration : 1,
        // type === 'task' ? parseInt(entity.getIn(['props', 'Duration (days)'])) : 1,
      id: entity.get('id'),
      level: 1,
      name: entity.get('name'),
      rowIndex: 1,
      successors: List(),
      type,
      onCriticalPath: elementInfo.onCriticalPath || false,
    };
  }
};

const calendarColumnBuilder = (projectStartDate, projectCalendar) => {
  const projectStartDateJSON = projectStartDate.toJSON();
  const adjustedStartDate = `${projectStartDateJSON.slice(0, projectStartDateJSON.indexOf('T'))}T12:00:00.000Z`;

  return projectCalendar.reduce((p, c) => {
    const dayOfWeek = getDay(parseISO(c));
    if (dayOfWeek === 0 || dayOfWeek === 6) return p;
    p[differenceInWeekDays(parseISO(c), parseISO(adjustedStartDate))] = true
    return p;
  }, {})
}

export const ganttDataBuilder = (
  sequencerData,
  wbsElements,
  elements,
  mappedRelationships,
  allRelationships,
  wbsRelTypeId,
  taskTypeId,
  dependencyTypeId,
  shouldLoadTask,
  shouldLoadMilestone,
  loadedAllElementTypes,
) => {
  if (
    shouldLoadMilestone ||
    shouldLoadTask ||
    !loadedAllElementTypes
  ) {
    return {
      tasks: List(),
      backwardDepedencies: Map(),
      columnCount: 0,
      calendarColumns: {},
    };
  }

  const wbsMapWithOrder = wbsElements.reduce((p, c, i) => {
    p[c.get('id')] = i + 1; // order number must always be greater than 0
    return p;
  }, {})

  const tasksData = sequencerData.CycleGantt(
    {
      id: sequencerData.currentProjectId,
      calendar: sequencerData.projectCalendar,
      startDate: sequencerData.projectStartDate,
      timezoneOffset: sequencerData.timezoneOffset,
    },
    sequencerData.filteredElements,
    sequencerData.relationships,
    wbsMapWithOrder,
  );

  // column offset for shading calendar holidays
  let caldendarOffset;
  const projectStartDay = parseISO(sequencerData.projectStartDate).getDay();
  if (projectStartDay === 0 || projectStartDay === 6 || projectStartDay === 1) {
    caldendarOffset = 0;
  } else {
    caldendarOffset = (projectStartDay - 1);
  }

  const calendarColumns = calendarColumnBuilder(
    subDays(parseISO(sequencerData.projectStartDate), caldendarOffset), sequencerData.projectCalendar
  );

  // column offset applied to task dates
  const offset = (tasksData.projectData.startDate.getDay()) + differenceInWeekDays(tasksData.projectData.startDate, parseISO(sequencerData.projectStartDate));

  const wbsRelationships = mappedRelationships.get(wbsRelTypeId, Map());
  const wbsRelMap = wbsElements.reduce(
    (p, c) => {
      p[c.get('id')] = List();

      return p;
    },
    {
      Unspecified: List(),
    },
  );

  tasksData.taskOrder.forEach(task => {
    const wbsRelationship = wbsRelationships.get(task, null);
    const elementInfo = tasksData.taskData[task];

    const element = elements.get(task);
    const elementTypeId = element.get('type_id');

    const data = dataBuilder(
      elementTypeId === taskTypeId ? 'task' : 'milestone',
      element,
      elementInfo,
      offset,
    );

    data.successors = tasksData.taskData[task].providesTo.reduce((p, c) => {
      const successor = allRelationships.getIn([c, 'consumer'], null);

      if (successor && !tasksData.relData[c]) {
        p = p.push(elements.get(successor));
      }

      return p;
    }, List());

    if (wbsRelationship) {
      const wbsElement = wbsRelationship.get('producer');
      const wbsLevel = wbsElements
        .find(wbs => wbs.get('id') === wbsElement)
        .get('level', 0);

      data.level = wbsLevel + 1;

      wbsRelMap[wbsElement] = wbsRelMap[wbsElement].push(data);
    } else {
      wbsRelMap.Unspecified = wbsRelMap.Unspecified.push(data);
    }
  });

  if (wbsRelMap.Unspecified.size === 0) {
    delete wbsRelMap.Unspecified;
  }

  if (wbsElements.length === 0 && !wbsRelMap.Unspecified) {
    return {
      tasks: List(),
      backwardDepedencies: Map(),
      columnCount: 0,
      calendarColumns: {},
    };
  }

  const baseOutput = wbsRelMap.Unspecified ?
    List()
      .concat(dataBuilder('wbs', null))
      .concat(wbsRelMap.Unspecified) :
    List()

  const output = wbsElements.reduce(
    (p, c) => {
      const newArray = p
        .concat(dataBuilder('wbs', c))
        .concat(wbsRelMap[c.get('id')]);

      return newArray;
    },
    baseOutput
  );

  const backwardDepedencies = Object.keys(tasksData.relData).reduce((p, c) => {
    const relationship = allRelationships.get(c);
    const producer = relationship.get('producer');
    const producerList = p.get(producer, List()).push(c);

    return p.set(producer, producerList);
  }, Map());

  // let firstColumn = -1;
  // let lastColumn = 0;
  // let lastMinestoneCheck = false;
  // let milestoneCount = 0;
  // let currentWbsLevel = -1;

  // const tasks = output.reverse().reduce((p, c, i) => {
  //   if (c.type === 'wbs') {
  //     const durationSum = lastMinestoneCheck ? lastColumn - firstColumn - milestoneCount : lastColumn - firstColumn;

  //     c.color = 'black';
  //     c.duration = durationSum;
  //     c.colIndex = firstColumn;
  //   } else {
  //     if (firstColumn < 0 || firstColumn > c.colIndex) {
  //       firstColumn = c.colIndex;
  //     }

  //     if (lastColumn < c.colIndex + c.duration) {
  //       lastColumn = c.colIndex + c.duration;
  //     }

  //     if (c.type === 'milestone' && c.colIndex >= lastColumn - 1) {
  //       lastMinestoneCheck = true;
  //       milestoneCount = 1;
  //     } else {
  //       lastMinestoneCheck = false;
  //       milestoneCount = 0;
  //     }
  //   }
  // }, List());

  function recurseChildren(arr, i, colIndex, lastColumnIndex, level) {
    const item = arr.get(i);

    if (i === arr.size) {
      return {
        colIndex,
        lastColumnIndex,
      }
    }

    if (item.type === 'wbs' && item.level !== 0 && level < item.level) {

      // const currentDuration = item.colIndex === -1 ? 0 : item.duration
      const currentLastColumnIndex = item.colIndex + item.duration;
      const newLastColumnIndex = currentLastColumnIndex > lastColumnIndex ? currentLastColumnIndex : lastColumnIndex;
      
      // const newColIndex = item.colIndex === -1 || ((colIndex < item.colIndex) && colIndex !== 0) ? colIndex : item.colIndex;
      // const newColIndex = ((colIndex < item.colIndex) && colIndex !== -1 && item.colIndex !== -1) ? colIndex : item.colIndex;
      let newColIndex;
      if (colIndex === -1) {
        newColIndex = item.colIndex;
      } else if (item.colIndex < colIndex && item.colIndex !== -1) {
        newColIndex = item.colIndex;
      } else {
        newColIndex = colIndex;
      }

      return recurseChildren(arr, i + 1, newColIndex, newLastColumnIndex, level);
    } else if (item.type === 'wbs' && item.level === 0 && level >= item.level) {
      return {
        colIndex,
        lastColumnIndex,
      };
    } else {
      return recurseChildren(arr, i + 1, colIndex, lastColumnIndex, level);
    }
  }

  const tasks = output.reduce((p, c, i) => {
    if (c.type === 'wbs') {
      let temp = i + 1;
      let durationSum = 0;
      let firstColumn = -1;
      let milestoneCount = 0;
      let lastMinestoneCheck = false;
      let lastColumn = 0;

      while (temp < output.size && output.get(temp).type !== 'wbs') {
        if (firstColumn < 0 || firstColumn > output.get(temp).colIndex) {
          firstColumn = output.get(temp).colIndex;
        }

        if (lastColumn < output.get(temp).colIndex + output.get(temp).duration) {
          lastColumn = output.get(temp).colIndex + output.get(temp).duration;
        }

        if (output.get(temp).type === 'milestone' && output.get(temp).colIndex >= lastColumn - 1) {
          lastMinestoneCheck = true;
          milestoneCount = 1;
        } else {
          lastMinestoneCheck = false;
          milestoneCount = 0;
        }

        temp += 1;
      }

      durationSum = lastMinestoneCheck ? lastColumn - firstColumn - milestoneCount : lastColumn - firstColumn;

      c.color = 'black';
      c.duration = durationSum;
      c.colIndex = firstColumn;
    }

    return p.push(c);
  }, List()).map((t, i, a) => {
    if (t.type !== 'wbs') return t;

    const currentLevel = t.type === 'wbs' ? t.level : -1;

    let temp = i + 1;

    while (temp < output.size && a.get(temp).type !== 'wbs') {
      temp += 1;
    }

    const nextItem = a.get(temp);
    const nextItemLevel = nextItem && nextItem.type === 'wbs' ? nextItem.level : -1;

    if (currentLevel < nextItemLevel) {
      const currentColIndex = t.colIndex === -1 ? -1 : t.colIndex;
      const currentDuration = t.colIndex === -1 ? 0 : t.duration;

      const data = recurseChildren(a, i + 1, currentColIndex, currentColIndex + currentDuration, t.level);

      t.duration = data.lastColumnIndex - data.colIndex;
      t.colIndex = data.colIndex;

      return t;
    }

    return t;
  });

  return {
    tasks,
    backwardDepedencies,
    calendarColumns,
    businessDaysDuration: tasksData.projectData.businessDaysDuration,
    columnCount: tasksData.projectData.duration+ differenceInWeekDays(tasksData.projectData.startDate, parseISO(sequencerData.projectStartDate)),
    cycleCount: tasksData.projectData.cycleCount,
    finishDate: tasksData.projectData.finishDate,
    duration: tasksData.projectData.calendarDaysDuration,
  }
};



// WEBPACK FOOTER //
// ./src/reducers/views.js